import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "./auth/auth.service";
import { environment } from "../environments/environment";
import { HttpClient } from "@angular/common/http";
import { MessageService } from "./@pages/components/message/message.service";

@Component({
  selector: "app-root",
  // template: '<router-outlet><app-spinner></app-spinner></router-outlet>',
  templateUrl: "app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "saferec.org";

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private http: HttpClient,
    private _notification: MessageService
  ) {
    this.initTranslate();
    this.getVersion();
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.addLangs(["en", "fr", "es"]);
    this.translate.setDefaultLang(environment.defaultLang);
    this.translate.use(environment.defaultLang); // Set your language here
    // const browserLang = this.translate.getBrowserLang();
    // this.translate.use(browserLang.match(/en|fr/) ? browserLang : environment.defaultLang);
  }

  ngOnInit() {
    this.authService.autoAuthUser();
  }

  getVersion() {
    const BACKEND_URL = environment.apiUrl + "/param";
    const self = this;
    const versionOld = (sv: string) => {
      let svSplit = sv.split(".");
      let envSplit = environment.version.split(".");
      let isLower = false;

      if (svSplit.length !== envSplit.length) {
        isLower = true;
      } else {
        for (let index = 0; index < envSplit.length; index++) {
          if (parseInt(envSplit[index]) < parseInt(svSplit[index])) {
            console.log("SDL");
            isLower = true;
            break;
          }
        }
      }
      if (isLower) {
        console.log("server:", sv);
        console.log("app:", environment.version);
      }
      return isLower;
    };
    if (
      // true ||
      environment.production
    ) {
      this.http
        .get<{
          version: string;
        }>(BACKEND_URL + "/version")
        .subscribe((postData) => {
          // console.log('got version ', postData)
          if (
            environment.production &&
            // || true
            versionOld(postData.version + "")
          ) {
            // if (postData.version > environment.version) {
            console.log("New Version required");
            self.translate.get("E_3").subscribe((res: string) => {
              const message = res;
              self._notification.create("danger", message, {
                Position: "top-right",
                Style: "flip",
                Duration: 0,
              });
              setTimeout(() => {
                window.location.reload();
              }, 5000);
            });
          }
        });
    }
  }
}
